import { Component, ReactElement } from 'react';
import Draggable from 'react-draggable';
import { connect } from 'react-redux';

import { bindActionCreators, Dispatch } from 'redux';
import {
    IsAnyOpendModelFunctionAction,
    isAnyOpenModelFunctionAction,
    SetCloseModelFunctionAction,
    setCloseModelFunctionAction,
    setOpenModelFunctionAction,
    SetOpenModelFunctionAction,
} from 'store/actions/layoutActions';
import { ActionsType } from 'types/system';
import { clone, getId } from 'utils/formHandlers';

import AddGridColumnModel from './grid/models/AddGridColumnModel';
import EditGridColumnModel from './grid/models/EditGridColumnModel';
import GridSettingModel from './grid/models/GridSettingModel';
import GridValueFilterModel from './grid/models/GridValueFilterModel';
import AboutModel from './main/models/AboutModel';
import AllTransitTagsAndCommentsModel from './main/models/AllTransitTagsAndCommentsModel';
import ClearSearchDataModel from './main/models/ClearSearchDataModel';
import DeleteTransitModel from './main/models/DeleteTransitModel';
import EditTransitModel from './main/models/EditTransitModel';
import EditTransitsModel from './main/models/EditTransitsModel';
import EraseAllModel from './main/models/EraseAllModel';
import EraseDrawingModel from './main/models/EraseDrawingModel';
import HelpVideosModel from './main/models/HelpVideosModel';
import KeyboardShortcutsModel from './main/models/KeyboardShortcutsModel';
import LabelDrawingModel from './main/models/LabelDrawingModel';
import ReAnalyseTransitModel from './main/models/ReAnalyseTransitModel';
import ReFetchMetoceantModel from './main/models/ReFetchMetoceantModel';
import ReplayModeTimeOutModel from './main/models/ReplayModeTimeOutModel';
import ReProcessTransitModel from './main/models/ReProcessTransitModel';
import SearchChangedModel from './main/models/SearchChangedModel';
import SearchVesselTransitModel from './main/models/SearchVesselTransitModel';
import SettingModel from './main/models/SettingModel';
import SystemUpdatedModel from './main/models/SystemUpdatedModel';
import TimeModeTimeOutModel from './main/models/TimeModeTimeOutModel';
import TransitTagsAndCommentsModel from './main/models/TransitTagsAndCommentsModel';
import UploadUpdateModel from './main/models/UploadUpdateModel';
import UserCreateTagModel from './main/models/UserCreateTagModel';
import UserDeleteCommentModel from './main/models/UserDeleteCommentModel';
import DeleteCommentModel from './managers/comments/models/DeleteCommentModel';
import EditCommentModel from './managers/comments/models/EditCommentModel';
import OpenCommentModel from './managers/comments/models/OpenCommentModel';
import DeletePortModel from './managers/ports/models/DeletePortModel';
import InitDefaultValueModal from './managers/ports/models/InitDefaultValueModal';
import DeleteSearchModel from './managers/searches/models/DeleteSearchModel';
import CreateTagModel from './managers/tags/models/CreateTagModel';
import DeleteTagModel from './managers/tags/models/DeleteTagModel';
import EditTagModel from './managers/tags/models/EditTagModel';
import OrderTagModel from './managers/tags/models/OrderTagModel';
import ReassignTagModel from './managers/tags/models/ReassignTagModel';
import TagFilterModel from './managers/tags/models/TagFilterModel';
import CreateUserModel from './managers/users/models/CreateUserModel';
import CreateUserPortModel from './managers/users/models/CreateUserPortModel';
import DeleteTokenModel from './managers/users/models/DeleteTokenModel';
import DeleteUserModel from './managers/users/models/DeleteUserModel';
import EditUserModel from './managers/users/models/EditUserModel';
import EditUserPortModel from './managers/users/models/EditUserPortModel';
import GetTokenModel from './managers/users/models/GetTokenModel';
import RestrictUserModel from './managers/users/models/RestrictUserModel';
import UserFilterModel from './managers/users/models/UserFilterModel';
import UserPortFilterModel from './managers/users/models/UserPortFilterModel';
import ChangeIntervalModel from './menus/models/ChangeIntervalModel';
import ChangeTimeModel from './menus/models/ChangeTimeModel';
import DateSelectModel from './menus/models/DateSelectModel';
import HeatmapSettingModel from './menus/models/HeatmapSettingModel';
import LoadPlaybackModeVesselErrorModel from './menus/models/LoadPlaybackModeVesselErrorModel';
import LoadTimeModeVesselErrorModel from './menus/models/LoadTimeModeVesselErrorModel';
import PilotagePlansSettingsModel from './menus/models/PilotagePlansSettingsModel';
import PlanFeatureModel from './menus/models/PlanFeatureModel';
import SaveSearchModel from './menus/models/SaveSearchModel';
import ScreenGridSettingModel from './menus/models/ScreenGridSettingModel';
import SearchLimit from './menus/models/SearchLimitModel';
import SearchTagsModel from './menus/models/SearchTagsModel';
import TimeSelectModel from './menus/models/TimeSelectModel';
import ProfileDataUpdatedModel from './profile/models/ProfileDataUpdatedModel';
import ProfileHistogramModel from './profile/models/ProfileHistogramModel';
import ProfileOptionsModel from './profile/models/ProfileOptionsModel';

interface ModalManagerProps {
    setOpenModelFunctionAction: SetOpenModelFunctionAction;
    isAnyOpenModelFunctionAction: IsAnyOpendModelFunctionAction;
    setCloseModelFunctionAction: SetCloseModelFunctionAction;
}

interface Modal {
    uuid: string;
    key: string;
    index?: number;
    type?: 'full' | 'small' | 'medium' | 'custom' | 'auto';
    data?: null;
    animation?: number;
    actions?: ActionsType | undefined;
    draggable?: boolean;
    width?: number;
}

interface ModalManagerState {
    models: Modal[];
}

class ModalManager extends Component<ModalManagerProps, ModalManagerState> {
    constructor(props: ModalManagerProps) {
        super(props);
        this.state = {
            models: [],
        };
    }

    componentDidMount(): void {
        this.props.isAnyOpenModelFunctionAction(this.isAnyOpenModel);
        this.props.setOpenModelFunctionAction(this.toggleModal);
        this.props.setCloseModelFunctionAction(this.closeModal);
    }

    closeModal = (key) => {
        this.setState({
            models: this.state.models.filter((x) => {
                return x.key !== key;
            }),
        });
    };

    isAnyOpenModel = (): boolean => {
        return this.state.models.length >= 1;
    };

    toggleModal = async (
        key: string,
        index?: number,
        type?: 'full' | 'small' | 'medium' | 'custom' | 'auto' | 'permanent',
        data?: object,
        actions?: ActionsType | undefined,
        draggable?: boolean,
        width?: number
    ) => {
        const { models } = this.state;
        const existingModel = models.find((model) => model.key === key);

        if (existingModel) {
            if (type === undefined || type !== 'permanent') {
                this.setState({
                    models: models.filter((x) => x.key !== key),
                });
            }
        } else {
            // Open modal
            const id = getId();
            await this.addModalAsync({
                uuid: id,
                key,
                index,
                type,
                data: clone(data),
                actions,
                animation: type && ['medium', 'full'].includes(type) ? -1500 : 0,
                draggable: draggable || false,
                width: width,
            });

            // Animate modal after adding it
            this.updateModalAnimation(key, id, type);
        }
    };

    // Helper function to add a modal and return a promise
    addModalAsync = (modal: any): Promise<void> => {
        return new Promise((resolve) => {
            this.setState(
                (prevState) => ({
                    models: [...prevState.models, modal],
                }),
                resolve // Resolve after the state is updated
            );
        });
    };

    // Helper function to update modal animation
    updateModalAnimation = (key: string, id: string, type?: string): void => {
        const delay = 300; // Animation delay in ms
        const animationValue = type && ['medium', 'full'].includes(type) ? 0 : 1;

        new Promise<void>((resolve) => setTimeout(resolve, delay)).then(() => {
            this.setState((prevState) => ({
                models: prevState.models.map((model) =>
                    model.key === key && model.uuid === id ? { ...model, animation: animationValue } : model
                ),
            }));
        });
    };
    getClassName = (type) => {
        switch (type) {
            case 'custom':
                return 'absolute m-auto ';
            case 'full':
                return 'absolute pl-center transition-all duration-300';
            case 'medium':
                return 'absolute m-auto  w-mediumModel';
            case 'large':
                return 'absolute m-auto  w-largeModel';
            case 'small':
                return 'absolute m-auto  w-smallModel';
            case 'auto':
                return 'absolute m-auto  w-auto';
            default:
                break;
        }
    };

    renderView = (
        uuid: string,
        type: 'full' | 'small' | 'medium' | 'custom' | 'auto',
        component: ReactElement,
        animation = 0,
        draggable = true,
        width?: number
    ) => {
        // Wrapper for the draggable element
        const draggableWrapper = (
            <Draggable disabled={!draggable} handle={`#Drag-${uuid}`}>
                <div
                    style={{
                        right: ['full'].includes(type) ? animation : undefined,
                        width: width,
                    }}
                    className={this.getClassName(type)}
                >
                    {component}
                </div>
            </Draggable>
        );

        return (
            <div key={uuid} className="fixed z-50 w-screen h-screen bg-black bg-opacity-20">
                {type === 'full' ? (
                    <div className="fixed w-full h-full  transition-all duration-300">{draggableWrapper}</div>
                ) : (
                    <div className="flex items-center justify-center align-middle w-screen h-screen">
                        {draggableWrapper}
                    </div>
                )}
            </div>
        );
    };

    render() {
        return (
            <>
                {this.state.models
                    .sort((a, b) => (a.index || 99) - (b.index || 99))
                    .map((model) => {
                        const { uuid, type = 'small', key, data, animation, draggable, width, actions } = model;

                        const components: Record<string, ReactElement> = {
                            pilotagePlansSettingsModel: (
                                <PilotagePlansSettingsModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            planFeatureModel: <PlanFeatureModel key={key} id={uuid} data={data} actions={actions} />,
                            changeIntervalModel: (
                                <ChangeIntervalModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            reFetchMetoceanModel: (
                                <ReFetchMetoceantModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            searchLimit: <SearchLimit key={key} id={uuid} data={data} actions={actions} />,
                            dateSelectModel: <DateSelectModel key={key} id={uuid} data={data} actions={actions} />,
                            transitTagsAndCommentsModel: (
                                <TransitTagsAndCommentsModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            allTransitTagsAndCommentsModel: (
                                <AllTransitTagsAndCommentsModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            gridSettingModel: <GridSettingModel key={key} id={uuid} data={data} actions={actions} />,
                            profileDataUpdatedModel: (
                                <ProfileDataUpdatedModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            usercreateTagModel: (
                                <UserCreateTagModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            loadTimeModeVesselErrorModel: (
                                <LoadTimeModeVesselErrorModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            eraseAllModel: <EraseAllModel key={key} id={uuid} data={data} actions={actions} />,
                            loadPlaybackModeVesselErrorModel: (
                                <LoadPlaybackModeVesselErrorModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            editTagModel: <EditTagModel key={key} id={uuid} data={data} actions={actions} />,
                            createTagModel: <CreateTagModel key={key} id={uuid} data={data} actions={actions} />,
                            deleteTagModel: <DeleteTagModel key={key} id={uuid} data={data} actions={actions} />,
                            initDefaultValueModal: (
                                <InitDefaultValueModal key={key} id={uuid} data={data} actions={actions} />
                            ),
                            deletePortModel: <DeletePortModel key={key} id={uuid} data={data} actions={actions} />,
                            addGridColumnModel: (
                                <AddGridColumnModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            editGridColumnModel: (
                                <EditGridColumnModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            tagFilterModel: <TagFilterModel key={key} id={uuid} data={data} actions={actions} />,
                            reassignTagModel: <ReassignTagModel key={key} id={uuid} data={data} actions={actions} />,
                            orderTagModel: <OrderTagModel key={key} id={uuid} data={data} actions={actions} />,
                            searchTagsModel: <SearchTagsModel key={key} id={uuid} data={data} actions={actions} />,
                            editTransitsModel: <EditTransitsModel key={key} id={uuid} data={data} actions={actions} />,
                            editTransitModel: <EditTransitModel key={key} id={uuid} data={data} actions={actions} />,
                            profileOptionsModel: (
                                <ProfileOptionsModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            profileHistogramModel: (
                                <ProfileHistogramModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            labelDrawingModel: <LabelDrawingModel key={key} id={uuid} data={data} actions={actions} />,
                            helpVideosModel: <HelpVideosModel key={key} id={uuid} data={data} actions={actions} />,
                            changeTimeModel: <ChangeTimeModel key={key} id={uuid} data={data} actions={actions} />,
                            aboutModel: <AboutModel key={key} id={uuid} data={data} actions={actions} />,
                            systemUpdatedModel: (
                                <SystemUpdatedModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            keyboardShortcuts: (
                                <KeyboardShortcutsModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            uploadUpdateModel: <UploadUpdateModel key={key} id={uuid} data={data} actions={actions} />,
                            clearSearchDataModel: (
                                <ClearSearchDataModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            searchChangedModel: (
                                <SearchChangedModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            searchVesselTransitModel: (
                                <SearchVesselTransitModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            timeSelectModel: <TimeSelectModel key={key} id={uuid} data={data} actions={actions} />,
                            gridValueFilterModel: (
                                <GridValueFilterModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            saveSearchModel: <SaveSearchModel key={key} id={uuid} data={data} actions={actions} />,
                            deleteSearchModel: <DeleteSearchModel key={key} id={uuid} data={data} actions={actions} />,
                            deleteTransitModel: (
                                <DeleteTransitModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            reAnalyseTransitModel: (
                                <ReAnalyseTransitModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            reProcessTransitModel: (
                                <ReProcessTransitModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            userDeleteCommentModel: (
                                <UserDeleteCommentModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            deleteCommentModel: (
                                <DeleteCommentModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            eraseDrawingModel: <EraseDrawingModel key={key} id={uuid} data={data} actions={actions} />,
                            userFilterModel: <UserFilterModel key={key} id={uuid} data={data} actions={actions} />,
                            openCommentModel: <OpenCommentModel key={key} id={uuid} data={data} actions={actions} />,
                            editCommentModel: <EditCommentModel key={key} id={uuid} data={data} actions={actions} />,
                            editUserModel: <EditUserModel key={key} id={uuid} data={data} actions={actions} />,
                            createUserModel: <CreateUserModel key={key} id={uuid} data={data} actions={actions} />,
                            deleteUserModel: <DeleteUserModel key={key} id={uuid} data={data} actions={actions} />,
                            deleteTokenModel: <DeleteTokenModel key={key} id={uuid} data={data} actions={actions} />,
                            getTokenModel: <GetTokenModel key={key} id={uuid} data={data} actions={actions} />,
                            createUserPortModel: (
                                <CreateUserPortModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            editUserPortModel: <EditUserPortModel key={key} id={uuid} data={data} actions={actions} />,
                            userPortFilterModel: (
                                <UserPortFilterModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            restrictUserModel: <RestrictUserModel key={key} id={uuid} data={data} actions={actions} />,
                            screenGridSettingModel: (
                                <ScreenGridSettingModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            heatmapSettingModel: (
                                <HeatmapSettingModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            timeModeTimeOutModel: (
                                <TimeModeTimeOutModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            replayModeTimeOutModel: (
                                <ReplayModeTimeOutModel key={key} id={uuid} data={data} actions={actions} />
                            ),
                            settingModel: <SettingModel key={key} id={uuid} data={data} actions={actions} />,
                        };

                        return components[key]
                            ? this.renderView(uuid, type, components[key], animation, draggable, width)
                            : null;
                    })}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
    isAnyOpenModelFunctionAction: bindActionCreators(isAnyOpenModelFunctionAction, dispatch),
    setOpenModelFunctionAction: bindActionCreators(setOpenModelFunctionAction, dispatch),
    setCloseModelFunctionAction: bindActionCreators(setCloseModelFunctionAction, dispatch),
});

export default connect(null, mapDispatchToProps)(ModalManager);
